import {makeStyles} from '@material-ui/core/styles';

export const stylesheet = {
    root: {
        minHeight: "100vh",
        backgroundColor: "#F3F4F8",
    },
    // header: {
    //     borderBottom: "1px solid #ebebeb",
    //     height: "75px",
    //     marginLeft: "-15px",
    //     marginRight: "-15px"
    // },
    // headerLogo: {
    //     display: "inline-block ",
    //     height: "auto ",
    //     lineHeight: "18px ",
    //     fontSize: ".875rem ",
    //     width: "180px ",
    //     maxWidth: "100% ",
    //     padding: "0 ",
    //     justifyContent: "Center "
    // },
    // messagingGroupsAll: {
    //     textStyle: "Core / LG / page-title",
    //     fontFamily: "Chronicle Text G1 ",
    //     fontStyle: "semiBold",
    //     fontSize: "48px ",
    //     align: "left",
    //     verticalAlign: "top",
    //     letterSpacing: "0.5px",
    //     paddingTop: "61px"
    // },
    // content: {
    //     color: "#6D6D6E ",
    //     fontSize: "32px ",
    //     fontStyle: "semiBold ",
    // },
    // subContent: {
    //     color: "#6D6D6E",
    //     fontSize: "20px ",
    //     fontFamily: "Whitney ",
    //     fontStyle: "semiBold",
    // },
    // divider: {
    //     width: "40px",
    //     fill: "solid",
    //     borderColor: "#B40F87 ",
    //     borderBottomWidth: "thick ",
    //     marginBottom: "16px !important"
    // },
    // paper: {
    //     boxShadow: "0px 0px 0px 0px !important",
    //     paddingTop: "46px !important"
    // },
    // basicInfo: {
    //     fontFamily: "Whitney !important",
    //     fontWeight: "bold !important",
    //     fontSize: "16px !important",
    //     align: "left",
    //     verticalAlign: "top"
    // },
    // ccInfo: {
    //     fontFamily: "Whitney !important",
    //     fontWeight: "bold !important",
    //     fontSize: "16px !important",
    //     align: "left",
    //     verticalAlign: "top",
    //     color: "rgba(0, 0, 0, 0.6)"
    // },
    // updateccInfo: {
    //     fontFamily: "Whitney !important",
    //     fontSize: "18px !important",
    //     align: "left",
    //     verticalAlign: "top",
    //     color: "rgba(0, 0, 0, 0.6)",
    //     marginTop: "32px",
    //     height: "32px"
    // },
    // lastName: {
    //     marginTop: "24px !important",
    // },
    // textField: {
    //     paddingTop: "6px !important",
    // },
    // dob: {
    //     marginTop: "42px !important",
    // },
    // button: {
    //     marginTop: "42px !important",
    // },
    // textInfo: {
    //     fontFamily: "Whitney !important",
    //     fontSize: "16px !important",
    //     align: "left",
    //     verticalAlign: "top"
    // },
    // textButton: {
    //     paddingLeft: "0px !important",
    //     fontFamily: "Whitney !important",
    //     fontWeight: "bold !important",
    //     letterSpacing: "1.25px",
    //     fontSize: "1rem !important",
    //     marginTop: "24px !important",
    //     marginBottom: "48px !important",
    // },
    // card: {
    //     padding: "24px !important",
    //     radius: "4px"
    // },
    // cardButton: {
    //     color: "#1E69D2 !important",
    //     borderColor: "#1E69D2 !important",
    //     marginBottom: "32px !important"
    // },
    // buttonFilled: {
    //     color: "#FFFFFF !important",
    //     borderColor: "#1E69D2 !important",
    //     backgroundColor: "#1E69D2 !important"
    // },
    // textButton2: {
    //     paddingLeft: "0px !important",
    //     fontFamily: "Whitney !important",
    //     fontWeight: "bold !important",
    //     letterSpacing: "1.25px",
    //     fontSize: "1rem !important",
    //     marginBottom: "48px !important",
    // },
    // alertContentCCPage: {
    //     fontFamily: "Whitney !important",
    //     fontSize: "16px !important",
    //     fontWeight: "bold !important"
    // },
    // alertSubContent: {
    //     fontFamily: "Whitney !important",
    //     fontSize: "16px !important",
    // },
    // alertBox: {
    //     borderLeft: "4px solid  #1E69D2 !important",
    //     marginTop: "32px !important"
    // },
    // lockIcon: {
    //     float: "left !important",
    //     paddingTop: "5px !important",
    //     paddingLeft: "13.5px !important",
    //     paddingRight: "13.5px !important",
    //     paddingBottom: "13.5px !important",
    //     fontSize: "1.7rem !important",
    //     color: "#1E69D2 !important"
    // },
    // staticTextField: {
    //     color: "#000000",
    //     fontFamily: "Whitney !important",
    //     fontSize: "16px !important",
    //     marginTop: "35px !important"
    // },
    // verifoneLogo: {
    //     width: "188px",
    //
    // },
    // alertContent: {
    //     marginTop: '46px !important',
    //     backgroundColor: "white !important",
    //     borderLeft: '5px solid #DB6200',
    //     boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.07), 0px 3px 3px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.1);'
    // },
    // alertSuccessContent: {
    //     marginTop: '46px !important',
    //     backgroundColor: "white !important",
    //     borderLeft: '5px solid #126E36',
    //     boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.07), 0px 3px 3px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.1);'
    // },
    // covidBanner: {
    //     backgroundColor: "#0F3C97",
    //     textAlign: "center",
    //
    //     fontFamily: "Whitney !important",
    //     minHeight: "50px !important"
    //
    // },
    // covidText: {
    //     color: "#FFFFFF",
    //     fontSize: "0.875rem !important",
    //     fontWeight: "350",
    //     fontFamily: "Whitney,sans-serif !important",
    //     textTransform: "uppercase",
    //     marginLeft: "auto !important",
    //     marginRight: "auto !important",
    //     borderBottom: "2px solid #FFFFFF",
    //     lineHeight: "22px !important",
    //     width: "auto !important",
    // },
    // expandIcon: {
    //     bottom: "14.21%",
    //     right: "-5.87%",
    //     left: "57.5%",
    //     position: "absolute",
    //     color: "#FFFFFF",
    //     display: "inline-block",
    //     textRendering: "auto",
    //     marginLeft: "5px",
    //     top: "50%",
    //     transform: "translateY(-50%)",
    //     font: "9px / 1 FontAwesome",
    // },
    // buttonFrame: {
    //     paddingLeft: "30px !important",
    //     fontSize: "0.65rem !important",
    //     fontWeight: "600 !important",
    //     fontColor: "#626262 !important",
    //     paddingRight: "5px !important",
    //     textTransform: "capitalize !important",
    //     fontFamily: "inherit !important",
    //     borderRight: "1px solid #ebebeb",
    //     backgroundColor: "#FFFFFF !important",
    //     color: "#626262 !important"
    //
    // },
    // toolbar: {
    //     minHeight: "0px !important",
    //     borderBottom: "1px solid #ebebeb"
    // },
    // appbar: {
    //     boxShadow: "none !important",
    //     margin: "0 !important",
    //     padding: "0 !important",
    //     backgroundColor: "#FFFFFF !important"
    // },
    // notlistedIcon: {
    //     paddingRight: "5px !important"
    // },
    // expandIcon2: {
    //     paddingLeft: "15px !important",
    // },
    // links: {
    //     padding: "0 15px !important",
    //     alignSelf: "flex-end !important",
    //     display: "inline-block !important",
    //     boxSizing: "border-box !important",
    //     position: "absolute",
    //     right: "0",
    //     lineHeight: "2.4"
    // },
    // linkField: {
    //     color: "#626262 !important",
    //     fontSize: "11px !important",
    //     fontWeight: "600 !important",
    //     letterSpacing: "1px !important",
    //     paddingRight: "28px",
    //     textDecoration: "none",
    //     letterspacing: "1px"
    // },
    // linkField2: {
    //     color: "#626262 !important",
    //     fontSize: "12px !important",
    //     fontWeight: "600 !important",
    //     letterSpacing: "1px !important",
    //     paddingRight: "28px !important",
    //     textDecoration: "none !important",
    //     letterspacing: "1px !important",
    //     textTransform: "uppercase !important"
    // },
    // searchLink: {
    //     display: "flex !important",
    //     fontFamily: "Whitney,sans-serif !important",
    //     fontStyle: "normal !important",
    //     fontWeight: "700 !important",
    //     fontSize: ".75rem !important",
    //     lineHeight: "34px !important",
    //     letterSpacing: "1.25px !important",
    //     color: "#1e69d2 !important",
    //     justifyContent: "center !important"
    // },
    // searchIcon:{
    //     height: "36px !important",
    //     fill: "#1e69d2 !important",
    //     padding: "0 8px 0 0px !important",
    //
    // }
}

export const styles = makeStyles(theme => stylesheet);

